// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "光热材料及应用技术",
      "tec": "刘莉莹",
      "week": "1,3-9周",
      "add": "教学楼D座125经管"
    },
    0,
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "锂离子电池应用技术",
      "tec": "王晗",
      "week": "1,3-9周",
      "add": "教学楼C座304教务"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "柔性太阳能电池",
      "tec": "王健",
      "week": "5-12周",
      "add": "教学楼B座218自控"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "现代储能技术",
      "tec": "侯锦秋",
      "week": "5-12周",
      "add": "教学楼D座121新能"
    },
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "光伏发电系统",
      "tec": "柯昀洁",
      "week": "5-12周",
      "add": "教学楼D座223经管"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
